import { InjectionToken } from "@angular/core";

export let EnvVariables = new InjectionToken("env.variables");



// WEBPACK FOOTER //
// ./src/app/environment-variables/environment-variables.token.ts